/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';
import { useQuery } from 'react-fetching-library';
import { useHistory, useParams } from 'react-router-dom';
import qs from 'qs';

import { useStyles } from './ParticipantSelection.styles';
import { useLocale } from 'shared/hooks/useLocale/useLocale';
import { Typography, Button, Image, Loader } from 'shared/components';
import { TemplateCard } from './templateCard/TemplateCard';
import { ParticipantSelectionHeader } from './header/ParticipantSelectionHeader';
import { ParticipantSelectionFooter } from './footer/ParticipantSelectionFooter';
import { participantSelection } from 'api/actions/participantSelection/participantClipping.actions';
import { ParticipantSelectionResponse } from 'api/actions/participantSelection/participantClipping.types';
import { AppRoute } from 'app/routing/AppRoute.enum';
import { NoClips } from './templateCard/noClips/NoClips';

export type EventIdParamType = { participantId: string };

export const ParticipantSelection = () => {
  const styles = useStyles();
  const { formatMessage } = useLocale();
  const id = useParams<EventIdParamType>();
  const { push } = useHistory();
  const params: any = qs.parse(window.location.href.split('?')[1]);

  const { isItemMatched } = params;

  const { payload, loading, error } = useQuery<ParticipantSelectionResponse>(participantSelection(id.participantId));

  const firstName = !error && payload?.fullName.split(' ');

  const isMatched = true;
  // const [isFromGifSelection, setIsFromGifSelection] = useState(false);

  const isFromGifSelection = false;

  const highMatch = (payload?.suggestions || []).find(item => item.matchRating > 80);
  const suggestions = payload?.suggestions || [];
  const maxMatchRating = Math.max(...suggestions.map(item => item.matchRating));

  const highMatches = suggestions.filter(item => item.matchRating === maxMatchRating);

  if (payload?.audioStartTime && !isItemMatched) {
    push(`${AppRoute.clipEdit}?id=${id.participantId}&isMatched=${isMatched}`, {
      maxMatchRating,
      isFromGifSelection,
    });
    // eslint-disable-next-line padding-line-between-statements
    return null;
  }

  if (!payload?.audioStartTime && highMatch && !isItemMatched && highMatches.length <= 1) {
    push(`${AppRoute.clipEdit}?id=${id.participantId}&isMatched=${isMatched}&userId=${highMatch.id}`, {
      maxMatchRating,
      isFromGifSelection,
    });
    // eslint-disable-next-line padding-line-between-statements
    return null;
  }

  return (
    <>
      {loading ? (
        <Loader fullScreen />
      ) : error ? (
        <NoClips />
      ) : (
        <div>
          <ParticipantSelectionHeader
            studentName={(firstName && firstName[0]) || ''}
            institutionLogo={payload?.institutionLogo || ''}
          />
          <div className={styles.container}>
            <div className={styles.logoContainer}>
              <Image className={styles.logoImage} alt="" src={payload?.institutionLogo || ''} />
            </div>
            <Typography className={styles.rootText}>
              {formatMessage({ id: 'studentSelection.selection_header' })}
            </Typography>
            {/* <Typography className={styles.subHeader}>
              {formatMessage({ id: 'studentSelection.selection_sub_header' })}
            </Typography> */}
            <Typography className={styles.subTitle}>
              {formatMessage({ id: 'studentSelection.selection_sub_title' })}
            </Typography>
            <div className={styles.buttonUpperContainer}>
              <Button
                className={styles.buttonText}
                onClick={() =>
                  push(`${AppRoute.clipEdit}?id=${id.participantId}`, {
                    maxMatchRating,
                    isFromGifSelection: true,
                    isSelfVisible: true,
                  })
                }
              >
                {formatMessage({ id: 'studentSelection.selection_button_text' })}
              </Button>
            </div>
            <div className={styles.containerX}>
              {!payload?.suggestions ? (
                <div className={styles.loaderResolution}>
                  <Typography className={styles.rootText}>
                    {formatMessage({ id: 'studentSelection.suggestions.empty' })}
                  </Typography>
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <Loader />
                  </div>
                </div>
              ) : (
                <>
                  <div className={styles.radioGroup}>
                    {(payload?.suggestions || []).map(item => (
                      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                      <div
                        onClick={() => {
                          push(`${AppRoute.clipEdit}?id=${id.participantId}&isMatched=${isMatched}&userId=${item.id}`, {
                            maxMatchRating,
                            isFromGifSelection: true,
                          });
                        }}
                        onKeyDown={() => {
                          push(`${AppRoute.clipEdit}?id=${id.participantId}&isMatched=${isMatched}&userId=${item.id}`, {
                            maxMatchRating,
                            isFromGifSelection: true,
                          });
                        }}
                      >
                        <TemplateCard key={item.id} name={item.matchRating.toFixed(2)} image={item.gifLink} />
                      </div>
                    ))}
                  </div>
                  <div className={styles.buttonContainer}>
                    <Button
                      className={styles.buttonText}
                      onClick={() =>
                        push(`${AppRoute.clipEdit}?id=${id.participantId}`, {
                          maxMatchRating,
                          isFromGifSelection: true,
                          isSelfVisible: true,
                        })
                      }
                    >
                      {formatMessage({ id: 'studentSelection.selection_button_text' })}
                    </Button>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className={styles.footerContainer}>
            <ParticipantSelectionFooter />
          </div>
        </div>
      )}
    </>
  );
};
